import {
  CENTER_X,
  CENTER_Y,
  PATTERN_STEP_DURATION,
} from './shared-ui-logo-loading.consts';
import {
  createPatternFrame,
  easeInOutSine,
  lerp,
} from './shared-ui-logo-loading.helpers';
import type { Circle, Point } from './shared-ui-logo-loading.types';

const GAP = 52;

const DOT_RADIUS = 34;

const CYCLES = 3;

const SLOTS: Point[] = [
  [-1, -1],
  [1, -1],
  [1, 1],
  [-1, 1],
];

const ROLE_SLOT_PATHS = [
  [0, 1, 1, 1, 2],
  [3, 3, 0, 0, 0],
  [2, 2, 2, 3, 3],
];

const START_ROLES = [0, 2, 1];

export function gridShufflePattern(elapsed: number): Circle[] {
  const cycle = Math.floor(elapsed / PATTERN_STEP_DURATION);
  const phase =
    ((elapsed - cycle * PATTERN_STEP_DURATION) / PATTERN_STEP_DURATION) * 4;
  const step = Math.min(3, Math.floor(phase));
  const progress = easeInOutSine(phase - step);

  return START_ROLES.map((startRole) => {
    const slotPath = ROLE_SLOT_PATHS[(((startRole - cycle) % 3) + 3) % 3];
    const [fromX, fromY] = SLOTS[slotPath[step]];
    const [toX, toY] = SLOTS[slotPath[step + 1]];
    return [
      CENTER_X + GAP * lerp(fromX, toX, progress),
      CENTER_Y + GAP * lerp(fromY, toY, progress),
      DOT_RADIUS,
    ];
  });
}

export const gridShuffleFrame = /* @__PURE__ */ createPatternFrame(
  gridShufflePattern,
  CYCLES
);
